<template>
    <Layout header-class="header-left-align" nav-alignment="left">
			<div class="top-page"
					 :style="{'background-image': `url(${require(`@/assets/images/partner-banner.png`)})`}">
				<h2 class="banner-title">链筑信任 智护未来</h2>
				<p class="banner-info" style="margin-top: 20px;"> 秉承“开放、协作、革新”的理念，实现“共建、共治、共荣”的愿景，构建生生不息的Web3安全新生态。</p>
			</div>

			<section class="members">
				<h2 class="title center70"> 伙伴单位 </h2>
				<h3 class="title center70" style="margin-top: 60px;">
					战略伙伴 <em>基础设施提供商，提供会员专属云安全方案折扣</em>
				</h3>
				<div class="center70">
					<div class="member-list">
						<div class="member">
							<img src="@/assets/images/aws.png">
						</div>
						<div class="member">
							<img src="@/assets/images/cloudflare.png" style="height: 60px">
						</div>
						<div class="member">
							<img src="@/assets/images/qty.png">
						</div>
						<div class="member">
							<img src="@/assets/images/ygy.png">
						</div>
					</div>
				</div>
				<h3 class="title center70">
					学术机构 <em>联合研究项目</em>
				</h3>
				<div class="center70">
					<div class="member-list">
						<div class="member">
							<img src="@/assets/images/mit.png">
						</div>
						<div class="member">
							<img src="@/assets/images/stanford.png" style="height: 40px">
						</div>
						<div class="member">
							<img src="@/assets/images/CCAF.png">
						</div>
						<div class="member">
							<img src="@/assets/images/MITDCI.png">
						</div>
					</div>
				</div>
				<h3 class="title center70">
					合作机构 <em>审计及服务机构</em>
				</h3>
				<div class="center70">
					<div class="member-list">
						<div class="member">
							<img src="@/assets/images/certik.png" style="height: 40px">
						</div>
						<div class="member">
							<img src="@/assets/images/quantstamp.png" style="height: 60px">
						</div>
						<div class="member">
							<img src="@/assets/images/chainlink.png">
						</div>
						<div class="member">
							<img src="@/assets/images/YugaLabs.png">
						</div>
					</div>
				</div>
			</section>

			<section class="members" style="background-color: #ffffff">
				<h2 class="title center70"> 会员单位 </h2>
				<div class="center70">
					<div class="member-list">
						<div class="member no-border">
							<img src="@/assets/images/member-binance.png">
						</div>
						<div class="member no-border">
							<img src="@/assets/images/member-okx.png">
						</div>
						<div class="member no-border">
							<img src="@/assets/images/member-huobi.png">
						</div>

						<div class="member no-border">
							<img src="@/assets/images/member-bybit.png">
						</div>
					</div>
				</div>
			</section>

    </Layout>
</template>

<script>
    import Layout from '../components/common/Layout'
    import SectionTitle from '../components/elements/sectionTitle/SectionTitle'
    import Icon from "@/components/icon/Icon.vue";
		import countTo from 'vue-count-to'

    export default {
        name: 'About',
        components: {Icon, SectionTitle, Layout, countTo},
        data() {
            return {
						}
        }
    }
</script>
<style scoped lang="scss">
section.members {
	background-color: #f4f4f4;
	padding: 80px 0 40px;
	h2.title {
		font-weight: 700;
		font-size: 40px;
		padding-bottom: 10px;
		margin-bottom: 20px;
	}
	h3.title {
		font-weight: 700;
		font-size: 28px;
		padding-bottom: 10px;
		margin-bottom: 20px;
		em {
			font-size: 16px;
			font-weight: normal;
			font-style: normal;
			margin-left: 12px;
			color: gray;
		}
	}
	.member-list {
		display: flex;
		margin: 40px 0 80px;
		gap: 80px;
		.member {
			transition: .6s;
			box-shadow: 0 0 8px rgba(0, 0, 0, .3);
			background-color: white;
			border-radius: 8px;
			width: 240px;
			height: 120px;
			text-align: center;
			padding: 20px 0;
			align-items: center;
			justify-content: center;
			display: flex;
			img {
				height: 80px;
				border-radius: 8px;
			}
			&:hover {
				transform: translateY(-5px);
			}
			&.no-border {
				padding: 0;
				border-radius: unset;
				background-color: transparent;
				box-shadow: unset;
				img {
					width: 240px;
					height: 120px;
				}
			}
		}
	}
}
@media screen and (max-width: 850px) {
	section.members {
		padding-top: 40px;
		h2.title {
			font-size: 28px;
			margin-bottom: 0;
		}
		h3.title {
			margin-top: 10px !important;
			font-size: 24px;
			display: flex;
			flex-direction: column;
			gap: 8px;
			em {
				margin-left: 0;
			}
		}
		.member-list {
			gap: 40px;
			flex-direction: column;
			align-items: center;
		}
	}
}
</style>
